'use client';
import { FC } from 'react';
import clsx from 'clsx';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { PatternPillCluster, PillClusterPillInput } from 'mmds';
import Linker from '@app/components/linker/linker';
import { Language } from '@app/lib/store-context/Context';
import s from './pill-cluster.module.css';

/**
 * Props for `PillCluster`.
 */
export type PillClusterProps = SliceComponentProps<Content.PillClusterSlice> & {
    context: {
        lang: Language;
    };
};

/**
 * Component for "PillCluster" Slices.
 */
const PillCluster: FC<PillClusterProps> = ({ slice, context }) => {
    const pills = slice.primary.pills || [];
    const stackOrSwipeOnMobile = slice.primary.swipe_on_mobile ? 'swipe' : 'stack';
    return (
        <section
            className={
                clsx(
                    s.pillCluster, 
                    { [s.stack]: stackOrSwipeOnMobile === 'stack'},
                    { [s.swipe]: stackOrSwipeOnMobile === 'swipe'},
                )
            }
            data-slice-type={slice.slice_type}
            data-slice-variation={slice.variation}
        >
            {slice.primary.cluster_heading && <h3 className={`${s.heading} mmds-component-one-detail`}>
                {slice.primary.cluster_heading}
            </h3>}
            <div className={s.cluster}>
                <PatternPillCluster
                    cluster={
                        pills.map((pill) => ({
                            componentType: 'button',
                            buttonVariant: pill.variant,
                            label: pill.label,
                            hrefLink: pill.link || '',
                            lang: context.lang,
                            icon:
                                !pill.icon || pill.icon === 'none'
                                    ? null
                                    : pill.icon,
                        })) as PillClusterPillInput[]
                    }
                    Linker={Linker}
                    // @ts-ignore
                    lang={context.lang as Language}
                    applyRowGap
                    mobileLayout={stackOrSwipeOnMobile}
                />
            </div>
        </section>
    );
};

export default PillCluster;
